<template>
  <div v-if="combo !== null" class="product-card-modal-body">
    <div v-if="comboItemProducts.length" class="col-left combo-item-products">
      <ComboItemProducts :products="comboItemProducts"></ComboItemProducts>
    </div>
    <div class="col col-left">
      <div class="combo-card-discount" v-if="combo.discount">{{combo.discount}}</div>
      <div class="product-card-title product-card-modal-title">
        {{ combo.title }}
      </div>
      <div class="product-card-modal-images">
        <img class="product-card-modal-image combo-modal-image"
             :src="combo.picture" :title="combo.title" :alt="combo.title">
      </div>
      <div class="col-footer">
        <div class="product-card-modal-price">{{ combo.price }}&#8381;</div>
      </div>
    </div>
    <div class="col col-right">
      <div class="col-right-body scroll-black">
        <div v-for="group in combo.raw.groups" :key="group.id" :class="{'active': comboItemGroupId === group.id}" class="combo-group">
          <div class="combo-group-title">{{ group.title }}</div>
          <div class="combo-group-items">
            <ComboItem :group-code="group.code" :group-id="group.id" :products="group.products"></ComboItem>
          </div>
        </div>
      </div>
      <div v-if="combo.code === undefined" class="product-card-button-action product-card-button-action"
           :class="{'blocked': isNotValidCombo(combo.raw.groups, comboItems), 'active': addedToBasket}" @click="addComboToBasket()">
        <span class="pp-icon pp-icon-basket-move"></span>
        <span class="product-card-button-action-title">{{ phrases.PRODUCT_CARD_BUTTON_ADD_TO_CARD }}</span>
      </div>
      <div v-else class="product-card-button-action product-card-button-action"
           :class="{'blocked': isNotValidCombo(combo.raw.groups, comboItems), 'active': addedToBasket}" @click="updateComboToBasket()">
        <span class="pp-icon pp-icon-basket-move"></span>
        <span class="product-card-button-action-title">{{ phrases.MODAL_COMBO_UPDATE_BUTTON }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import ComboUtils from "@/components/combos/ComboUtils.vue";
  import Utils from "@/components/Utils.vue";
  import {mapGetters} from "vuex";
  import ComboItem from "@/components/combos/ComboItem.vue";
  import ComboItemProducts from "@/components/combos/ComboItemProducts.vue";

  export default {
    name: "ComboModalBody",
    data: function() {
      return {
        addedToBasket: false
      }
    },
    props: {
      combo: {},
    },
    components: {ComboItem, ComboItemProducts},
    computed:{
      ...mapGetters('combo', {
        comboItems: 'getComboItems',
        comboItemProducts: 'getComboItemProducts',
        comboItemGroupId: 'getComboItemGroupId',
      }),
      ...mapGetters('order', {
        orderCombos: 'getOrderCombos'
      }),
    },
    methods: {
      addComboToBasket: function (){
        const component = this;
        if(component.isNotValidCombo(component.combo.raw.groups, component.comboItems)){
          return;
        }
        const combo = component.buildComboBasketItem(component.combo, component.comboItems, component.orderCombos.length);
        component.$store.dispatch('order/addToBasket', {offer: combo}).then( function () {
          component.calculateDiscount();
        });
        component.addedToBasket = true;
        setTimeout(function () {
          component.addedToBasket = false;
        }, 400);
      },
      isNotValidCombo: function(comboGroups, comboItems){
        return comboGroups.length !== comboItems.length;
      },
      updateComboToBasket: function (){
        const component = this;
        if(component.isNotValidCombo(component.combo.raw.groups, component.comboItems)){
          return;
        }
        const comboBasketItem = component.buildComboBasketItem(component.combo, component.comboItems, component.orderCombos.length);
        component.$store.commit('order/updateCombo', comboBasketItem);
        component.$store.commit('combo/setCombo', null);
        component.$store.commit('combo/setComboItems', []);
        component.$store.commit('catalog/setSelectedProductLargeCard', null);
      }
    },
    mixins: [ComboUtils, Utils]
  }
</script>

<style scoped lang="scss">
  .combo-modal{
    .col-left,
    .col-right{
      width: 50%;
    }

    .combo-card-discount{
      font-size: 1rem;
      line-height: 1rem;
    }

    .combo-group{
      margin: 0 0 0.5rem 0;
      text-transform: uppercase;

      &-title{
        margin: 0 0 0.25rem 0;
        font-size: 1rem;
        font-family: "Panton  Bold", sans-serif;
      }
    }

    .product-card-button-action{
      &.blocked{
        opacity: 0.5;
        cursor: default;
      }
    }
  }

  .col-left.combo-item-products{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 10;
    background: #fff;
    padding: 0;
  }

  @media screen and ((max-width:800px) or (max-height:600px)) {
    .combo-modal {
      .button-product-card-close {
        right: -0.25rem;
        top: -0.5rem;
      }

      .combo-card-discount {
        right: 2.5rem;
      }

      .product-card-modal-images {
        text-align: center;

        .combo-modal-image {
          max-height: 32vh;
        }
      }

      .product-card-modal-title {
        font-size: 1.5rem;
        line-height: 1.5rem;
      }

      .product-card-modal-price {
        font-size: 1.5rem;
      }

      .product-card-modal-body {
        flex-direction: column;
        height: auto;

        .col-left {
          width: 100%;
          height: 32vh;
          padding-top: 0;
          padding-bottom: 0;
        }

        .col-right {
          width: 100%;
          height: 52vh;
        }
      }

      .col-left.combo-item-products {
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        padding-top: 40%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
    }
  }
</style>